/** Origin of the Rails API (same host as GraphQL / company login). */
export function railsApiOrigin(): string {
  const graphql = process.env.VUE_APP_API_TARGET;
  if (graphql) {
    try {
      return new URL(graphql).origin;
    } catch {
      /* ignore */
    }
  }
  const signIn = process.env.VUE_APP_SIGN_IN_URL;
  if (signIn) {
    try {
      return new URL(signIn).origin;
    } catch {
      /* ignore */
    }
  }
  return "";
}
